exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-datatable tr td[data-v-c22591d0]:last-child {\n  display: flex;\n  justify-content: center;\n}\n", ""]);

// exports
